import "./contact.scss";
import { useState } from "react";
import emailjs from 'emailjs-com'

//From Yt - Code with Voran

export default function Contact() {
  const [message, setMessage] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_w71d1yt','template_yn1c7d9',e.target,'user_DWMHdHC5aPJUfyIJygEts');
    setMessage(true);
  };
  return (
    <div className="contact" id="contact">
      <div className="left">
        <img src="assets/shake.svg" alt="" />
      </div>
      <div className="right"> 
        <h2>Contact.</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Email" />
          <textarea name="message" placeholder="Message"></textarea>
          <button type="submit">Send</button>
          {message && <span>Thank you for Contacting :)</span>}
        </form>
      </div>
    </div>
  );
}
